import React, { PureComponent } from "react";

import style from "./style.module.css";


const Points = () => (
  <div className={style.points}>
    <div>
      <img src={"/icons/a.png"} />
    </div>
    <div>
      <img src={"/icons/b.png"} />
    </div>
  </div>
);

function formatTimeGainValue(val) {
  const numVal = parseFloat(val);
  if (numVal === 0) {
    return "";
  }
  if (numVal < 0) {
    return ` / ${numVal * -1}% faster `;
  }
  return ` / ${numVal}% slower`;
}

const TimeStatus = ({ color, timeValue, timeGainValue }) => (
  <span className={style.timeValue}>
    {timeValue ? timeValue : "-:-"}min{" "}
    {timeGainValue && timeGainValue !== "null"
      ? formatTimeGainValue(timeGainValue)
      : "-"}
  </span>
);

export class TravelTime extends PureComponent {
  render() {
    const { timeValue, timeGainValue, disabled, staticContent } = this.props;
    return (
      <div className={`mapStatus ${style.wrapper} ${disabled && "disabled"}`}>
        <span className={"subTitle"}>{staticContent.title}</span>
        <div className={style.innerWrapper}>
          <Points />
          <TimeStatus timeValue={timeValue} timeGainValue={timeGainValue} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/travel-time/index.js